import { Box, Skeleton, Stack } from '@mui/material';

export default function OperatorCardsSkeleton() {
  return [0, 1].map((_, i) => <OperatorCardSkeleton key={i} idx={i} />);
}

function OperatorCardSkeleton({ idx }: { idx?: number }) {
  return (
    <Box border='1px solid #ECECEC' borderRadius='12px' px={3} py={2.5} bgcolor='#fff'>
      <Stack direction='row' justifyContent='space-between'>
        <Stack spacing={1} width='60%'>
          <Skeleton variant='text' width='40%' height={28} />

          <Stack direction='row' spacing={6}>
            <Skeleton variant='text' width={160} />
            <Skeleton variant='text' width={120} />
          </Stack>
        </Stack>

        <Skeleton variant='circular' width={32} height={32} />
      </Stack>
      {idx === 0 ? (
        <Box mt={2} border='1px solid #E5E7EB' borderRadius={2} p={1.5}>
          <Stack direction='row' justifyContent='space-between' alignItems='center'>
            <Skeleton variant='text' width={120} />
            <Skeleton variant='circular' width={20} height={20} />
          </Stack>

          <Box mt={2}>
            <Skeleton variant='rectangular' height={120} sx={{ borderRadius: 2 }} />
          </Box>
        </Box>
      ) : (
        <Box mt={2}>
          <Skeleton variant='rectangular' height={50} sx={{ borderRadius: 2 }} />
        </Box>
      )}
    </Box>
  );
}
